import { render, staticRenderFns } from "./wjNewsList.vue?vue&type=template&id=fa0d76c6&"
import script from "./wjNewsList.vue?vue&type=script&lang=js&"
export * from "./wjNewsList.vue?vue&type=script&lang=js&"
import style0 from "./wjNewsList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports